module.exports = __webpack_public_path__ + "static/media/ic-join-video-chat.c6eb01f4.svg";